import { Spinner } from 'react-bootstrap';
import themes from 'styles/themes';

export const QuizSpinner = () => {
    return (
        <Spinner
            animation="border"
            style={{
                minWidth: 32,
                minHeight: 32,
                color: themes.palette.primary.main,
                marginTop: 55,
                alignSelf: 'center',
            }}
        />
    );
};
